import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

interface SetItem {
  id: string;
  number: number;
  reps: number;
  minutes: number;
  seconds: number;
  distance: number | "";
  energy_zone: string;
  description?: string;
}

interface SetCardProps {
  set: SetItem;
  energyZones: string[];
  onUpdate: (id: string, field: keyof SetItem, value: any) => void;
  onDelete: (set: SetItem) => void;
}

export function SetCard({ set, onUpdate, onDelete }: SetCardProps) {
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-background cursor-pointer hover:shadow-md transition space-y-3">

      <div className="flex justify-between items-center">
        <span className="font-medium">Reps: {set.reps} x</span>
        <Badge variant="outline">{set.distance} m</Badge>
      </div>

      <div className="flex justify-between items-center">
        <span className="text-sm">
          Interval: {set.minutes}:{set.seconds.toString().padStart(2, "0")}
        </span>
        <Badge variant="secondary">{set.energy_zone}</Badge>
      </div>

      {/* Description Field */}
      <div>
        <label className="text-xs text-muted-foreground">Description</label>
        <input
          type="text"
          value={set.description || ""}
          onChange={(e) => onUpdate(set.id, "description", e.target.value)}
          placeholder="Enter description"
          className="w-full mt-1 px-2 py-1 border rounded-md text-sm"
        />
      </div>

      <div className="flex justify-end">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(set)}
          className="text-destructive hover:text-destructive hover:bg-destructive/10"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>

    </div>
  );
}
